import pictures from '../../assests/assestimport.js';
const {bp} = pictures;

const boots=[
    {
        id:1,
        label:'PRIME 418',
        band:"talan",
        description:`Talan safety shoes S1P
        High ankle
        EN ISO 20345:2016 - S1P
        Steel toe - 200 joules impact protection`,
        image:bp[0],
        alt:"Talan PRIME 418 Boot",
        hscode:''
    },
    {
        id:2,
        label:'PRIME 545',
        band:"talan",
        description:`Talan safety shoes S3 SRC
        High ankle
        EN ISO 20345: 2011`,
        image:bp[1],
        alt:"Talan PRIME 545 Boot",
        hscode:''
    },
    {
        id:3,
        label:'SE/2M0112',
        band:"talan",
        description:`Talan safety shoes
        Steel Toe Cap, with 200 Joules impact protection.
        Steel midsole, antistatic insole, comfort insock`,
        image:bp[2],
        alt:"Talan SE/2M0112 Boot",
        hscode:''
    },
    {
        id:4,
        label:'SE/2M0162',
        band:"talan",
        description:`Talan safety shoes
        Steel midsole, antistatic insole, comfort insock.
        ual-density polyurethane PU-PU: antistatic, shock-absorbing, oil and slip resistant.
        Steel or Composite
        Toe Cap with 200 Joules impact protection`,
        image:bp[3],
        alt:"Talan SE/2M0162 Boot",
        hscode:''
    },
    {
        id:5,
        label:'SE/2M0182',
        band:"talan",
        description:`Talan rigger Boot
        S1P - CE EN 345
        High quality natural leather,240 mm high,boot-straps .
        Steel Toe Cap,200 Joules.
        Steel midsole,antistatic insole,comfort insock`,
        image:bp[4],
        alt:"Talan SE/2M0182 Boot",
        hscode:''
    },
    {
        id:6,
        label:'2C0170(yel)',
        band:"talan",
        description:`Talan safety shoes
        EN 20345:2011 S1P
        Breathable, wear-resistant lining material Mesh
        Fiberglass toe cup with 200 Joules impact protection
        Antistatic protection
        Oil and fuel resistant sole
        Kevlar midsole for 0% penetration`,
        image:bp[5],
        alt:"Talan 2C0170(yel) Boot",
        hscode:''
    },
    {
        id:7,
        label:'CH/2C111/37',
        band:"talan",
        description:`Talan safety shoes
        CE EN 345 S1P
        Breathable,wear-resistant lining material Mesh,nonwoven vamp lining material
        Composite Toe Cap, with 200 Joules impact protection
        Penetration,antistatic insole,comfort insock
        Dual-density polyurethane PU-PU: antistatic,shock-absorbing,oil and slip resistant
        Convenient anatomical last,individual cardboard box.`,
        image:bp[6],
        alt:"Talan CH/2C111/37 Boot",
        hscode:''
    },
    {
        id:8,
        label:'Harvik 9687',
        band:"Harvik",
        description:`Harvik 9687L Electrical Insulative Black/ Yellow Fireman Boot`,
        image:bp[7],
        alt:"Harvik 9687 Boot",
        hscode:''
    },
    {
        id:9,
        label:'Electrical Insulating Fireman Boot',
        band:"Harvik",
        description:`Electrical Insulating Fireman Boot
        Feature: Vulcanized Rubber Upper and Sole, Hypalon Lacquer type finishing, Chemical Resistant - Upper - Resistant towards mild acids and alkali, Sole – Resistant towards mild acids. 
        Sole Protection : Black in Colour, 80% Chloroprene Rubber & 20% Nitrile Rubber Oil Resistant – Immersion in iso-octane (22 hours at 22 ºC) 12% max change in volume. Abrasion Resistant – DIN 53516 : 250mm3 max. Hardness Shore A : 65 ± 5. Sole Protection Electric Shock Resistant, meets CSA – Z195-M92
        Steel Toe : Meets EN 345 Impact and Compression.
        COLOR : Black /Yellow
        SIZES : 38 - 46`,
        image:bp[8],
        alt:"Harvik Electrical Insulating Fireman Boot",
        hscode:''
    },
    {
        id:10,
        label:'Bulldozer Fire Fighting Boot',
        band:"Bulldozer",
        description:`Feature: Vulcanized Rubber Upper and Sole, Hypalon Lacquer type finishing, Chemical Resistant - Upper - Resistant towards mild acids and alkali, Sole – Resistant towards mild acids. 
        Sole Protection : Black in Colour, 80% Chloroprene Rubber & 20% Nitrile Rubber Oil Resistant – Immersion in iso-octane (22 hours at 22 ºC) 12% max change in volume. Abrasion Resistant – DIN 53516 : 250mm3 max. Hardness Shore A : 65 ± 5. Sole Protection Electric Shock Resistant, meets CSA – Z195-M92
        Steel Toe : Meets EN 345 Impact and Compression.
        COLOR : Black /Yellow
        SIZES : 38 - 46`,
        image:bp[9],
        alt:"Bulldozer Fire Fighting Boot",
        hscode:''
    },
    {
        id:11,
        label:'FORMIO',
        band:"Robusta",
        description:`100% non- metallic
        Water repellent cowhide leather(WRU)
        Features non-metallic toe-cap 200J
        olyamide lining with high abrasion resistant, breathability and non-allergic
        Antibacterial insole
        Resistant to 18.000 volts at 60 hertz for one minute`,
        image:bp[10],
        alt:"Robusta 100% non-matallic Boot",
        hscode:''
    },
    {
        id:12,
        label:'Safety Shoes Low Ankle ',
        band:"Milesttone",
        description:`Safety Shoes Low Ankle  Breathable Leather with Cool comfort Technique. Oil Resistant. 
        Steel Toe Cap & Steel Mid Plate. PU Sole with Padded Insole. Origin - Made In India.`,
        image:bp[11],
        alt:"Milesttone low ankle safety Boot",
        hscode:''
    },
    {
        id:13,
        label:'Safety Shoes Low Ankle',
        band:"Soldier",
        description:`Safety Shoes Low Ankle Breathable Leather with Cool comfort Technique. Oil Resistant. 
        Steel Toe Cap & Steel Mid Plate. PU Sole with Padded Insole.  Origin - Made In India`,
        image:bp[12],
        alt:"Soldier low ankle safety Boot",
        hscode:''
    },
    {
        id:14,
        label:'Safety Shoes High Ankle',
        band:"Soldier",
        description:`Safety Shoes High Ankle Breathable Leather with Cool comfort Technique. Oil Resistant. 
        Steel Toe Cap & Steel Mid Plate. PU Sole with Padded Insole. Origin - Made In India.`,
        image:bp[13],
        alt:"Soldier high ankle safety Boot",
        hscode:''
    },
    {
        id:15,
        label:'TYVEK Shoes Cover',
        band:"TYVEK",
        description:`DUPONT- Tyvek Antistatic/Antislip Shoe Cover D13398551 (42-46)`,
        image:bp[14],
        alt:"TYVEK Boot cover",
        hscode:''
    },
    {
        id:16,
        label:'SP800FW',
        band:"Safety Plus World",
        description:`SAFETYPLUS SAFETY SHOES S3SRC
        Upper:Black embossed leather, Sole: Single density, Black PU for comfort & weight, Steel toe cap & steel mid plate, Slip resistance as per SRC standard
        Upper: Black Embossed Split Genuine Leather
        Outsole: Dual Density PU Sole for comfort &
        light weight
        Steel Toe Cap & Anti Penetration steel plate
        Slip resistance as per SRC standard
        Size: 39-47
        Conformity: EN ISO 20345:2011
        `,
        image:bp[15],
        alt:"Safety Plus World shoes SP800FW",
        hscode:''
    },
    {
        id:17,
        label:'SP801FW',
        band:"Safety Plus World",
        description:`SAFETYPLUS SAFETY SHOES S3SRC
        Upper:Black embossed leather, Sole: Single density, Black PU for comfort & weight, Steel toe cap & steel mid plate, Slip resistance as per SRC standard
        Upper: Black Embossed Split Genuine Leather
        Outsole: Dual Density PU Sole for comfort & light weight
        Steel Toe Cap & Anti Penetration steel plate
        Slip resistance as per SRC standard
        Size: 39-47
        Conformity: EN ISO 20345:2011
        `,
        image:bp[16],
        alt:"Safety Plus World shoes SP801FW",
        hscode:''
    }
]
export default boots;